import styled from 'styled-components'
import { Label1 } from '../../theme/typography'

export const BackgroundDiv = styled.div`
  background: #fff;
  width: 98%;
  margin: 1rem;
  padding-bottom: 1rem;
  border-radius: 10px;
`

export const Container = styled.div`
  padding-top: 1rem;
  background: #f5f7fa;
  height: 100vh;
`
export const WhitelistContainer = styled.div`
  display: flex;
  justify-content: left;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  padding: 1rem;
  margin-left: 1rem;
`
export const AddWhitelistContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #e8f0f7;
  border-radius: 10px;
  width: 35%;
  height: 3rem;

  margin-left: 2rem;

  input {
    background: #e8f0f7;
    /* background: rgba(0,0,0,0.3); */
    border: none;
    outline: none;
    width: 80%;
    height: 80%;
    font-size: 1.2rem;
    padding-left: 1rem;
    color: rgba(0, 0, 0);
    border-radius: 5px;
    @media (max-width: 1024px) {
      font-size: 1rem;
      font-weight: 400;
      padding: 10px;
    }
  }

  form {
    display: flex;
    justify-content: space-between;
  }
  button {
    width: 2rem;
    height: 2rem;
    color: #2d60ff;
    font-size: 1.2rem;
    background: #ffffff;
    box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
    border-radius: 6px;
    border: none;
    margin-right: 0.7rem;
  }
`
export const L1 = styled(Label1)`
  padding: 1rem;
  margin-left: 2rem;
`
export const RadioStyled = styled.div`
  display: flex;
  width: 40%;
  font-size: 1.2rem;
  font-weight: 600;
  div {
    margin: 2rem auto;
    label {
      margin: 0.5rem;
    }
  }
`
